'use client';

import type { ProductInformation } from '@dealerportal/common';
import { useTranslations } from '@dealerportal/i18n/client';
import { useClientContext } from '@dealerportal/react-helpers';
import { BetterButton } from '@dealerportal/ui-components/BetterButton';

export const AddToCart = ({
  productInfo,
}: {
  productInfo: ProductInformation;
}) => {
  const ctx = useClientContext();
  const t = useTranslations('products');

  return (
    <BetterButton
      label={t('addToCart')}
      labelClassName="ui-text-sm"
      btnStyle="primary"
      attributes={{
        id: 'adhawk-shopify-camilyo-marketplace-add-to-cart',
        'data-product-handle': productInfo.UPID,
        'data-universal-retailer-id': ctx.universalRetailerId,
      }}
    />
  );
};
